import { render, staticRenderFns } from "./Shaped.vue?vue&type=template&id=edb6b5a0&"
import script from "./Shaped.vue?vue&type=script&lang=js&"
export * from "./Shaped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports